export default __webpack_public_path__ + "alberta-checkbox-empty.fc21958e5dfa322d8c10.svg";